import * as React from "react";

import { IconProps } from "./types";

const PunchupVerifiedIcon = (props: IconProps) => (
  <svg
    width={props.width ?? 30}
    height={props.height ?? 30}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 30 30"
    {...props}
  >
    <path
      d="M4.133 10.493a5.333 5.333 0 0 1 6.373-6.36 5.333 5.333 0 0 1 8.987 0 5.333 5.333 0 0 1 6.373 6.374 5.333 5.333 0 0 1 0 8.986 5.333 5.333 0 0 1-6.36 6.373 5.333 5.333 0 0 1-9 0 5.334 5.334 0 0 1-6.373-6.36 5.334 5.334 0 0 1 0-9.013Z"
      fill="#FE5E25"
      stroke="#FE5E25"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.52 20.937a.906.906 0 0 0 .336.064.89.89 0 0 0 .59-.222l2.267-2.015h8.047c1.235 0 2.24-.934 2.24-2.082v-.702h-7.16c-.207 0-.374-.157-.374-.351v-.1c0-.195.167-.352.374-.352H22v-1.255h-7.16c-.207 0-.374-.158-.374-.352v-.1c0-.195.167-.352.374-.352H22v-1.255h-7.16c-.207 0-.374-.157-.374-.352v-.1c0-.194.167-.351.374-.351H22C21.986 9.922 20.986 9 19.76 9h-9.52c-1.236 0-2.24.934-2.24 2.083v9.121c0 .32.203.606.52.732Z"
      fill="#fff"
    />
  </svg>
);

export default PunchupVerifiedIcon;
